import axios from "axios";

import store from "../../store";
import { RESPONSE_HEADER } from "../enums";

export const sendError = async (error, type) => {
  if (!error) return;
  const { configStorage } = store.getState();
  let requestData = configStorage.getRequestData("logError", "post");
  // skip interceptors
  const instance = axios.create({});
  const reqData = configStorage.isVerseNeo() ? requestData.json : {}
  const data = {
    ...reqData,
    errorLink: window.location.href,
    errorInfo: type + ' - ' + error.message,
    errorStack: type + ' - ' + error.stack
  }
  const result = await instance[requestData.request.type](requestData.url, data)
    .then(errorReponse => {
      if (errorReponse && errorReponse.data && errorReponse.data.header && errorReponse.data.header.status === RESPONSE_HEADER.STATUS.SUCCESSFUL) {
        return true;
      }
    })
    .catch(error => {
      console.error("Logging Error", error);
      return false;
    });
  return result;
};

export default sendError;
